export default __webpack_public_path__ + "static/media/SS3-min.9fa9a05a.png";